<template>
  <v-container>
    <v-layout>
      <v-flex md3></v-flex>
      <v-flex md9></v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import expandedPanel from '@/components/ExpandedPanel/ExpandedPanel'
export default {
  name: 'catalog',
  components: {
    expandedPanel
  },
  data() {
    return {

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/apps/bpm/catalog/components/Catalog.vue